/** Labels for admin permission checkboxes (keys must match server `ALL_CONSOLE_PERMISSION_KEYS`). */
export const CONSOLE_PERMISSION_LABELS: { id: string; label: string }[] = [
  { id: "leads", label: "Leads (view table & filters)" },
  { id: "leads_import", label: "Leads import (PDF/Excel upload only)" },
  { id: "applications", label: "Applicants — full access (all dossier tabs + registry)" },
  { id: "dossier_tab_overview", label: "Applicants — tab: Overview" },
  { id: "dossier_tab_beneficiary", label: "Applicants — tab: Beneficiary & documents" },
  { id: "dossier_tab_validation", label: "Applicants — tab: Verification & Aadhaar seeding" },
  { id: "dossier_tab_banking", label: "Applicants — tab: ICICI & MOU" },
  { id: "dossier_tab_subcontractor", label: "Applicants — tab: Subcontractor" },
  { id: "dossier_tab_work_progress", label: "Applicants — tab: Work progress" },
  { id: "dossier_tab_po_register", label: "Applicants — tab: PO register" },
  { id: "dossier_tab_milestones", label: "Applicants — tab: Milestones" },
  { id: "dossier_tab_bills", label: "Applicants — tab: Bills" },
  {
    id: "applications_no_edit",
    label: "Applicants — view only (open dossiers but cannot save changes)",
  },
  { id: "bills_inward", label: "Bills inward" },
  { id: "bills_outward", label: "Bills outward" },
  { id: "reports", label: "Area reports" },
  { id: "geo_tree", label: "Area tree (district → mandal → village view + add leads)" },
  { id: "geo_directory", label: "Geo directory (read map data)" },
  { id: "geo_directory_admin", label: "Geo directory admin (edit districts/mandals/villages)" },
  { id: "geo_zones", label: "Zones" },
  { id: "subcontractor_masters", label: "Subcontractor" },
  { id: "agents", label: "Agent master" },
  { id: "milestone_templates", label: "Milestone master" },
  { id: "construction_timeline", label: "Timeline master" },
  { id: "standard_resources", label: "Standard resources" },
  { id: "standard_item_catalogue", label: "Standard item catalogue" },
  { id: "inventory_issue_po", label: "PO format & PO register" },
  { id: "inventory_issue_material", label: "Material register" },
  { id: "inventory_inward", label: "Inventory inward" },
  { id: "inventory_goods_receipts", label: "Goods receipts" },
  { id: "inventory_store_stocks", label: "Store stocks" },
  { id: "inventory_stores_yards", label: "Stores & yards" },
  { id: "inventory_outward", label: "Inventory outward" },
  { id: "console_users", label: "Console users" },
  { id: "audit_log", label: "Audit log (activity report)" },
];
